import logger from "Libs/logger";
import { getProjectConfiguration } from "Api/projects/getProjectConfiguration.request";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";
import { configurationWizardDataSelector } from "../configurationWizard.selectors";
import { updateLoadingMessage } from "../configurationWizard.slice";

import type { ProjectConfiguration } from "../types";

export type GetConfigurationResult = {
  config: ProjectConfiguration;
  generatedAt: string;
};

export const getConfiguration = createAppAsyncThunk<
  GetConfigurationResult,
  {
    projectId: string;
    environmentId: string;
  }
>(
  "configurationWizard/getConfiguration",
  async (
    { projectId, environmentId },
    { rejectWithValue, signal, dispatch }
  ) => {
    try {
      const config = await getProjectConfiguration(
        projectId,
        signal,
        message => {
          dispatch(updateLoadingMessage({ projectId, environmentId, message }));
        }
      );
      return { config, generatedAt: new Date().toISOString() };
    } catch (error: unknown) {
      if (error instanceof DOMException && error.name === "AbortError") {
        return rejectWithValue({ error: "Request was cancelled" });
      }

      const message =
        error instanceof Error
          ? error.message
          : "Failed to generate configuration";

      logger(message, {
        action: "configurationWizard/getConfiguration"
      });

      return rejectWithValue({ error: message });
    }
  },
  {
    condition: ({ projectId, environmentId }, { getState }) => {
      const entry = configurationWizardDataSelector(getState(), {
        projectId,
        environmentId
      });

      return !!projectId && !!environmentId && entry?.phase !== "loading";
    }
  }
);
